(() => {
  const sliderSelector = 'slider-component [id^="Slider-"], slideshow-component [id^="Slider-"]';

  const initializeSlider = (slider) => {
    if (slider.dataset.sitewideCarouselInteractions === 'true') return;
    if (
      slider.matches(
        '.myproductpage .product__media-wrapper .thumbnail-list, .myproductpage .product__media-wrapper .product__media-list'
      )
    ) return;
    slider.dataset.sitewideCarouselInteractions = 'true';

    let activePointerId = null;
    let pointerStartX = 0;
    let pointerStartScrollLeft = 0;
    let pointerMoved = false;
    let suppressClick = false;
    let wheelSettleTimer = 0;
    const dragThreshold = 3;

    slider.addEventListener('dragstart', (event) => event.preventDefault());

    slider.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (slider.scrollWidth <= slider.clientWidth + 2) return;

      activePointerId = event.pointerId;
      pointerStartX = event.clientX;
      pointerStartScrollLeft = slider.scrollLeft;
      pointerMoved = false;
      suppressClick = false;
    });

    slider.addEventListener('pointermove', (event) => {
      if (event.pointerId !== activePointerId) return;

      const distance = event.clientX - pointerStartX;
      if (!pointerMoved && Math.abs(distance) <= dragThreshold) return;

      if (!pointerMoved) {
        pointerMoved = true;
        slider.setPointerCapture(activePointerId);
        slider.classList.add('sitewide-carousel-is-dragging');
      }

      event.preventDefault();
      slider.scrollLeft = pointerStartScrollLeft - (distance * 1.35);
    });

    const finishPointerDrag = (event) => {
      if (event.pointerId !== activePointerId) return;

      const pointerId = activePointerId;
      activePointerId = null;
      suppressClick = pointerMoved;
      slider.classList.remove('sitewide-carousel-is-dragging');
      if (slider.hasPointerCapture(pointerId)) slider.releasePointerCapture(pointerId);
    };

    slider.addEventListener('pointerup', finishPointerDrag);
    slider.addEventListener('pointercancel', finishPointerDrag);

    slider.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);

    slider.addEventListener('wheel', (event) => {
      if (slider.scrollWidth <= slider.clientWidth + 2) return;
      const isHorizontalGesture = Math.abs(event.deltaX) > Math.abs(event.deltaY);
      const isShiftWheel = event.shiftKey && Math.abs(event.deltaY) > 0;
      if (!isHorizontalGesture && !isShiftWheel) return;

      event.preventDefault();
      slider.classList.add('sitewide-carousel-is-dragging');
      slider.scrollLeft += (isHorizontalGesture ? event.deltaX : event.deltaY) * 1.25;
      window.clearTimeout(wheelSettleTimer);
      wheelSettleTimer = window.setTimeout(() => {
        slider.classList.remove('sitewide-carousel-is-dragging');
      }, 110);
    }, { passive: false });

    if (!slider.hasAttribute('tabindex')) slider.setAttribute('tabindex', '0');
    slider.addEventListener('keydown', (event) => {
      if (slider.scrollWidth <= slider.clientWidth + 2) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

      event.preventDefault();
      const items = Array.from(slider.querySelectorAll('.slider__slide')).filter((item) => item.clientWidth > 0);
      const step = items.length > 1
        ? Math.abs(items[1].offsetLeft - items[0].offsetLeft)
        : Math.max(1, slider.clientWidth * 0.8);
      slider.scrollBy({
        left: event.key === 'ArrowRight' ? step : -step,
        behavior: 'smooth'
      });
    });
  };

  const initializeWithin = (root = document) => {
    root.querySelectorAll('slideshow-component.announcement-bar').forEach((component) => {
      const slider = component.querySelector('[data-autoplay]');
      if (!slider || component.getClientRects().length > 0) return;

      slider.setAttribute('data-autoplay', 'false');

      if (component.autoplay) {
        clearInterval(component.autoplay);
        component.autoplay = null;
      }

      if (typeof component.pause === 'function') component.pause();
    });

    root.querySelectorAll(sliderSelector).forEach(initializeSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWithin(), { once: true });
  } else {
    initializeWithin();
  }

  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();
